import { Badge } from '@/components/ui/badge';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';

export const Chip = ({ children, className }) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-medium leading-5',
      className
    )}
  >
    {children}
  </span>
);

export const SectionTitle = ({ children, action }) => (
  <div className="mb-2 flex items-center justify-between">
    <h2 className="text-sm font-semibold tracking-wide text-foreground/90">{children}</h2>
    {action}
  </div>
);

const TONE_COLORS = {
  brand: 'var(--brand-gradient)',
  gold: '#F2C14E',
  violet: 'linear-gradient(90deg, #8B6CFF 0%, #4D8DFF 100%)',
  danger: '#FF5C7A',
  green: '#2FE6A6',
};

export const ProgressBar = ({ value = 0, tone = 'brand', className }) => {
  const color = TONE_COLORS[tone] || TONE_COLORS.brand;
  return (
    <div className={cn('h-2 w-full overflow-hidden rounded-full bg-white/10', className)}>
      <div
        className="h-full rounded-full transition-[width] duration-500"
        style={{ width: `${Math.max(0, Math.min(100, value))}%`, background: color }}
      />
    </div>
  );
};

export const EmptyState = ({ icon: Icon, title, subtitle, action }) => (
  <div className="glass-card flex flex-col items-center rounded-2xl px-6 py-10 text-center">
    {Icon ? (
      <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-white/[0.06] text-brand-cyan">
        <Icon className="h-6 w-6" />
      </div>
    ) : null}
    <p className="text-sm font-semibold text-foreground/90">{title}</p>
    {subtitle ? <p className="mt-1 text-xs text-foreground/55">{subtitle}</p> : null}
    {action ? <div className="mt-4">{action}</div> : null}
  </div>
);

export { Badge, Progress };
